import { Component, OnInit } from '@angular/core';
import { NavigateService } from '../../service/navigate.service';
import { ProDevService } from '../../service/pro-dev.service';

@Component({
	selector: 'app-webinar',
  	templateUrl: './webinar.component.html',
  	styleUrls: ['./webinar.component.styl', '../../share/breadcrumb/breadcrumb.component.styl']
})
export class WebinarComponent implements OnInit{
	webinarList: any = [];
	page: any = {
		pageIndex: 1,
		pageCount: 1,
	};

  	constructor(
        private navigateService: NavigateService,
		private proDevService: ProDevService
	){}

  	ngOnInit(){
		this.getWebinarList();
	}
    
    // 获取视频列表
	getWebinarList(pageIndex = 1){
        this.page.pageIndex = pageIndex;
		this.proDevService.getVideoList({ pageIndex }).subscribe(res => {
			if (res.status === 200){
				this.webinarList = res.rows || [];
				this.page.pageCount = Math.ceil(res.total / 10);
			}
		});
	}

    // 查看详情
	goDetail(id: number | string){
        this.navigateService.push();
        this.navigateService.pushToRoute(`/development/webinar/detail/${id}`);
	}
}


// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/professional-dev/webinar/webinar.component.ts